angular.module("ainapp")
    .controller("receiptReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "All Receipt Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }




            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    VoucherNo: "",
                    AccountIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                }

                $scope.load = false;
                $scope.isFilter = false;

            }
            $scope.Init();



            $scope.areaSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.accountInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    //toastr.error("NetworkError");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectAccountsOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.areaSelectDataSource
            };




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isFilter) {


                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            o.data.FromYear = $scope.filter.FromDate.getFullYear();
                            o.data.AccountIds = $scope.filter.AccountIds;

                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            o.data.ToYear = $scope.filter.ToDate.getFullYear();

                            //                        o.data.CustomerId = $scope.filter.CustomerId;
                            o.data.VoucherNo = $scope.filter.VoucherNo;
                            //                        o.data.ProductId = $scope.filter.ProductId;


                            MainService.ReceiptReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            VoucherType: {
                                type: "string",
                                editable: false,
                            },
                            Description: {
                                type: "string",
                                editable: false,
                            },
                            Amount: {
                                type: "number",
                                editable: false,
                            },
                            MasterTotal: {
                                type: "number",
                                editable: false,
                            },
                            MasterCalcGrandTotal: {
                                type: "number",
                                editable: false,
                            },
                            MasterConversionRate: {
                                type: "number",
                                editable: false,
                            },
                            Account: {
                                type: "string",
                                editable: false,
                            },
                            MasterRemarks: {
                                type: "string",
                                editable: false,
                            },
                            MasterDate: {
                                type: "date",
                                editable: false,
                            },
                            VoucherNumber: {
                                type: "string",
                                editable: false,
                            },
                            Currency: {
                                type: "string",
                                editable: false,
                            },
                            MasterAccount: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [

                    {
                        field: "Amount",
                        aggregate: "sum"
                        },

                    ],
            });

            $scope.KendoGridOptions = {


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [

                    {
                        field: "VoucherNumber",
                        title: "Doc No #",
                        width: "120px",
                        },
                    {
                        field: "VoucherType",
                        title: "Doc Type",
                        width: "120px",
                        },
                    {
                        field: "MasterDate",
                        title: "Doc Date",
                        template: "#= kendo.toString(kendo.parseDate(MasterDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",

                        },
                    {
                        field: "Account",
                        title: "Account",
                        width: "100px",
                                            },

                    {
                        field: "Amount",
                        title: "Amount",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Amount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Amount</div>")
                        },

                    {
                        field: "Currency",
                        title: "Currency",
                        width: "100px",
                                            },
                    {
                        field: "MasterAccount",
                        title: "Main Account",
                        width: "100px",
                                            },
                    {
                        field: "Description",
                        title: "Remarks",
                        width: "200px",
                                            },
                    ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

                MainService.PrintTempReceiptReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
